import React from 'react';
import { MAT } from './catalog';

const woodLines = (c2) => [12, 34, 58, 77, 101, 126, 147].map((x, i) => (
  <path key={i} d={`M${x} 0 C${x + 9} 260 ${x - 9} 520 ${x + 3} 760 S${x - 6} 1050 ${x} 1200`}
    stroke={c2} strokeOpacity={0.22 + (i % 3) * 0.1} strokeWidth={1.5 + (i % 3) * 1.6} fill="none" />
));

const marbleVeins = (c2) => (
  <g fill="none" stroke={c2} strokeLinecap="round">
    <path d="M-50 180 C180 120 300 420 520 360 S820 520 1050 430" strokeWidth="7" strokeOpacity="0.5" />
    <path d="M-50 640 C220 700 380 560 600 720 S880 860 1050 800" strokeWidth="4" strokeOpacity="0.45" />
    <path d="M200 -50 C260 180 160 300 300 520 S260 860 380 1050" strokeWidth="2" strokeOpacity="0.4" />
    <path d="M700 -50 C640 160 780 300 720 480" strokeWidth="1.6" strokeOpacity="0.35" />
    <path d="M520 360 C600 300 660 330 760 260" strokeWidth="2" strokeOpacity="0.35" />
  </g>
);

function MatPattern({ id, m, p }) {
  const pid = `${p}-${id}`;
  if (m.kind === 'wood') return (
    <pattern id={pid} patternUnits="userSpaceOnUse" width="160" height="1200">
      <rect width="160" height="1200" fill={m.c} />
      <rect x="40" width="50" height="1200" fill="#fff" opacity="0.05" />
      {woodLines(m.c2)}
    </pattern>
  );
  if (m.kind === 'marble') return (
    <pattern id={pid} patternUnits="userSpaceOnUse" width="1000" height="1000">
      <rect width="1000" height="1000" fill={m.c} />
      {marbleVeins(m.c2)}
    </pattern>
  );
  if (m.kind === 'stone') return (
    <pattern id={pid} patternUnits="userSpaceOnUse" width="300" height="300">
      <rect width="300" height="300" fill={m.c} />
      {[[30, 40, 26], [120, 90, 14], [210, 30, 20], [60, 200, 18], [250, 170, 30], [160, 250, 12], [90, 140, 8]].map(([x, y, l], i) => (
        <path key={i} d={`M${x} ${y} h${l}`} stroke={m.c2} strokeWidth="5" strokeLinecap="round" opacity="0.6" />
      ))}
    </pattern>
  );
  if (m.kind === 'metal') return (
    <pattern id={pid} patternUnits="userSpaceOnUse" width="40" height="40">
      <rect width="40" height="40" fill={m.c} />
      <path d="M0 8h40M0 21h40M0 33h40" stroke={m.c2} strokeWidth="2" opacity="0.45" />
    </pattern>
  );
  if (m.kind === 'floor-wood') return (
    <pattern id={pid} patternUnits="userSpaceOnUse" width="190" height="1900">
      <rect width="190" height="1900" fill={m.c} />
      <path d="M0 0V1900M0 640h190M95 1400h95" stroke={m.c2} strokeWidth="4" opacity="0.7" />
      <path d="M60 0 C70 400 50 900 64 1900M130 0 C120 600 140 1200 126 1900" stroke={m.c2} strokeWidth="1.5" opacity="0.35" fill="none" />
    </pattern>
  );
  if (m.kind === 'floor-stone') return (
    <pattern id={pid} patternUnits="userSpaceOnUse" width="600" height="600">
      <rect width="600" height="600" fill={m.c} />
      <path d="M0 0H600M0 0V600" stroke={m.c2} strokeWidth="5" opacity="0.8" />
      <path d="M80 420 C200 380 320 470 520 400" stroke={m.c2} strokeWidth="2" opacity="0.4" fill="none" />
    </pattern>
  );
  return (
    <pattern id={pid} patternUnits="userSpaceOnUse" width="400" height="400">
      <rect width="400" height="400" fill={m.c} />
      <path d="M0 120 L400 60 M0 300 L400 250" stroke="#000" strokeWidth="30" opacity="0.025" />
    </pattern>
  );
}

export function MatDefs({ p, mats }) {
  const front = MAT[mats.front];
  return (
    <defs>
      {Object.entries(MAT).map(([id, m]) => <MatPattern key={id} id={id} m={m} p={p} />)}
      <pattern id={`${p}-wine`} patternUnits="userSpaceOnUse" width="120" height="120">
        <rect width="120" height="120" fill="#1b1512" />
        <circle cx="60" cy="60" r="26" fill="#3d1720" stroke="#140a0c" strokeWidth="4" />
        <circle cx="0" cy="0" r="26" fill="#22301f" /><circle cx="120" cy="0" r="26" fill="#22301f" />
        <circle cx="0" cy="120" r="26" fill="#22301f" /><circle cx="120" cy="120" r="26" fill="#22301f" />
        <path d="M0 0L120 120M120 0L0 120" stroke={front.c} strokeWidth="9" />
      </pattern>
      <pattern id={`${p}-wicker`} patternUnits="userSpaceOnUse" width="40" height="40">
        <rect width="40" height="40" fill="#c7a574" />
        <path d="M0 10h40M0 30h40" stroke="#9c7b4c" strokeWidth="5" />
        <path d="M10 0v10M30 10v20M10 30v10" stroke="#9c7b4c" strokeWidth="4" />
      </pattern>
      <linearGradient id={`${p}-led`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffd9a0" stopOpacity="0.95" />
        <stop offset="1" stopColor="#ffb85c" stopOpacity="0" />
      </linearGradient>
      <linearGradient id={`${p}-mirror`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#dfe6e8" /><stop offset="0.5" stopColor="#b7c3c7" /><stop offset="1" stopColor="#e9eeef" />
      </linearGradient>
      <linearGradient id={`${p}-glass`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#dff1f2" stopOpacity="0.35" /><stop offset="1" stopColor="#a9c9cc" stopOpacity="0.18" />
      </linearGradient>
      <linearGradient id={`${p}-sky`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#c9d6dc" /><stop offset="1" stopColor="#f2ece2" />
      </linearGradient>
      <pattern id={`${p}-hatch`} patternUnits="userSpaceOnUse" width="60" height="60" patternTransform="rotate(45)">
        <rect width="60" height="60" fill="#d9d3c8" /><path d="M0 0V60" stroke="#2b2622" strokeWidth="6" />
      </pattern>
      <linearGradient id={`${p}-niche`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#000" stopOpacity="0.15" /><stop offset="0.55" stopColor="#000" stopOpacity="0.32" /><stop offset="1" stopColor="#000" stopOpacity="0.55" />
      </linearGradient>
      <linearGradient id={`${p}-ledL`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#ffd9a0" stopOpacity="0.75" /><stop offset="1" stopColor="#ffb85c" stopOpacity="0" />
      </linearGradient>
      <linearGradient id={`${p}-ledR`} x1="1" y1="0" x2="0" y2="0">
        <stop offset="0" stopColor="#ffd9a0" stopOpacity="0.75" /><stop offset="1" stopColor="#ffb85c" stopOpacity="0" />
      </linearGradient>
      <linearGradient id={`${p}-sheen`} x1="0" y1="0" x2="1" y2="0.3">
        <stop offset="0" stopColor="#fff" stopOpacity="0.16" /><stop offset="0.45" stopColor="#fff" stopOpacity="0" /><stop offset="1" stopColor="#000" stopOpacity="0.22" />
      </linearGradient>
      <linearGradient id={`${p}-cloth`} x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#fff" stopOpacity="0.18" /><stop offset="0.6" stopColor="#000" stopOpacity="0.05" /><stop offset="1" stopColor="#000" stopOpacity="0.35" />
      </linearGradient>
      <linearGradient id={`${p}-floorShade`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffe7c2" stopOpacity="0.25" /><stop offset="1" stopColor="#000" stopOpacity="0.25" />
      </linearGradient>
      <filter id={`${p}-wc`} x="-5%" y="-5%" width="110%" height="110%">
        <feTurbulence type="fractalNoise" baseFrequency="0.018" numOctaves="2" seed="7" result="n" />
        <feDisplacementMap in="SourceGraphic" in2="n" scale="12" xChannelSelector="R" yChannelSelector="G" />
      </filter>
      <filter id={`${p}-paper`} x="0" y="0" width="100%" height="100%">
        <feTurbulence type="fractalNoise" baseFrequency="0.035" numOctaves="3" seed="2" />
        <feColorMatrix values="0 0 0 0 0.55  0 0 0 0 0.47  0 0 0 0 0.36  0 0 0 0.09 0" />
      </filter>
      <filter id={`${p}-glow`} x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="28" />
      </filter>
    </defs>
  );
}
